/**
 * TanStack Query hooks for `lead-validation-logic-native-no-external-required`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	leadValidationLogicNativeNoExternalRequiredQueryKeys,
	type CreateLeadValidationLogicNativeNoExternalRequiredBody,
	type ListLeadValidationLogicNativeNoExternalRequiredResponse,
	type LeadValidationLogicNativeNoExternalRequiredRow,
} from "./api";

export function useLeadValidationLogicNativeNoExternalRequiredList(): UseQueryResult<ListLeadValidationLogicNativeNoExternalRequiredResponse, Error> {
	return useQuery({
		queryKey: leadValidationLogicNativeNoExternalRequiredQueryKeys.list(),
		queryFn: list,
	});
}

export function useLeadValidationLogicNativeNoExternalRequiredCreate(): UseMutationResult<LeadValidationLogicNativeNoExternalRequiredRow, Error, CreateLeadValidationLogicNativeNoExternalRequiredBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: leadValidationLogicNativeNoExternalRequiredQueryKeys.all });
		},
	});
}

export function useLeadValidationLogicNativeNoExternalRequiredDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: leadValidationLogicNativeNoExternalRequiredQueryKeys.all });
		},
	});
}
